import React from 'react'

import s from './Indicator.module.scss'

export const LoadingIndicator: React.FC<{
    isHubSpotLoader?: boolean
}> = ({ isHubSpotLoader = false }) => {
    if (isHubSpotLoader) {
        return (
            <div id="hubspot-container" className={s['hubspot-container']}>
                <div className={s['loading-container']}>
                    <span className={s['loading-message']} />
                </div>
            </div>
        )
    }

    return (
        <div className={s['loading-container']}>
            <span className={s['loading-message']} />
        </div>
    )
}
